import React from 'react';
import { useCallback, useState } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { ApiStatus } from 'Enums';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { getDifferenceInMinutesFromNow } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import { getSessionObject } from 'Utilities/storage';
import { store } from 'Utilities/store';
import { OAuthAcceptLogin } from 'Services/auth';
import useApiError from './useApiError';
const useAuth = () => {
  const [isLocked, setIsLocked] = useState(false);
  const [lockoutMessage, setLockoutMessage] = useState('');
  const [lockoutSubmessage, setlockoutSubmessage] = useState('');
  const {
    showApiErrorModal
  } = useApiError();
  const handleLogin = async ({
    email,
    password
  }) => {
    try {
      const challenge = store.getState().nav.query.challenge || store.getState().nav.query.login_challenge || getSessionObject('login_challenge'); // TODO: don't know if this is needed when using the redux i put just because is how legacy use

      const oAuthAcceptResponse = await OAuthAcceptLogin({
        challenge: challenge ?? '',
        password: password.trim(),
        username: email.trim()
      });
      if (oAuthAcceptResponse.status !== 0) {
        throw oAuthAcceptResponse;
      }
      oAuthAcceptResponse.data?.redirect_to && window.location.assign(oAuthAcceptResponse.data?.redirect_to);
      return oAuthAcceptResponse;
    } catch (err) {
      return err;
    }
  };
  const handleUnexpectedError = useCallback(() => {
    showApiErrorModal();
  }, [showApiErrorModal]);
  const showLockoutMessage = useCallback(attemptsResetAt => {
    const {
      time,
      difference
    } = getDifferenceInMinutesFromNow(attemptsResetAt);
    if (difference < 0) {
      return;
    }
    setIsLocked(true);
    setLockoutMessage(i18n.t('Login.modals.signInErrors.accountLocked'));
    setlockoutSubmessage(i18n.t('Login.modals.signInErrors.accountLockedPeriod', {
      time
    }));
    const lockoutInterval = setInterval(() => {
      const {
        time,
        difference
      } = getDifferenceInMinutesFromNow(attemptsResetAt);
      if (difference < 0) {
        clearInterval(lockoutInterval);
        setLockoutMessage('');
        setlockoutSubmessage('');
        setIsLocked(false);
      } else {
        setlockoutSubmessage(i18n.t('Login.modals.signInErrors.accountLockedPeriod', {
          time
        }));
      }
    }, 1000);

    // TODO:this still needed?
    // onDisplayLockoutMessage && onDisplayLockoutMessage();
  }, []);
  const showLoginFailure = useCallback((attemptsRemaining = -1, attemptsResetAfter, attemptsResetAt, onCloseAfterLockout, onClose) => {
    const modalProps = {
      details: /*#__PURE__*/React.createElement(Stack, {
        gap: 4
      }, /*#__PURE__*/React.createElement(Text, {
        color: "$text.100",
        type: "$bodyBase.default",
        nativeID: "Login.modals.signInErrors.loginFailure",
        testID: "Login.modals.signInErrors.loginFailure",
        marginBottom: "$1"
      }, i18n.t('Login.modals.signInErrors.loginFailure')), attemptsRemaining >= 0 ? /*#__PURE__*/React.createElement(Stack, {
        display: "inline"
      }, /*#__PURE__*/React.createElement(Text, {
        color: "$text.100",
        type: "$bodyBase.default",
        nativeID: "Login.modals.signInErrors.attemptsRemaining",
        testID: "Login.modals.signInErrors.attemptsRemaining"
      }, i18n.t(`${attemptsRemaining === 1 ? 'Login.modals.signInErrors.attemptsRemaining' : 'Login.modals.signInErrors.attemptsRemaining_other'}`, {
        count: attemptsRemaining
      })), attemptsResetAfter ? /*#__PURE__*/React.createElement(Text, {
        color: "$text.100",
        type: "$bodyBase.medium",
        nativeID: "Login.modals.signInErrors.accountWillBeLocked",
        testID: "Login.modals.signInErrors.accountWillBeLocked"
      }, i18n.t('Login.modals.signInErrors.accountWillBeLocked', {
        time: attemptsResetAfter,
        duration: attemptsResetAfter
      })) : null) : null),
      testID: 'Auth'
    };
    modalProps.onClose = () => {
      onClose && onClose();
    };
    if (attemptsResetAfter && attemptsResetAt) {
      modalProps.onClose = () => {
        showLockoutMessage(attemptsResetAt);
        onCloseAfterLockout && onCloseAfterLockout();
      };
    }
    store.dispatch({
      type: SHOW_MODAL,
      modalProps
    });
  }, [showLockoutMessage]);
  const handleCountryRegionError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Login.modals.signInErrors.regionDoesNotMatch'),
        testID: 'RegionError'
      }
    });
  }, []);
  const handleApiRequestError = useCallback(error => {
    switch (error) {
      case ApiStatus.INVALID_CREDENTIALS:
        {
          showLoginFailure();
          break;
        }
      case ApiStatus.WRONG_REGION:
        {
          handleCountryRegionError();
          break;
        }
      case ApiStatus.ERROR:
      default:
        handleUnexpectedError();
    }
  }, [handleCountryRegionError, handleUnexpectedError, showLoginFailure]);
  return {
    isLocked,
    setIsLocked,
    lockoutMessage,
    setLockoutMessage,
    lockoutSubmessage,
    setlockoutSubmessage,
    showLoginFailure,
    handleLogin,
    handleApiRequestError
  };
};
export default useAuth;